import React from 'react';

import { Box } from '@components/Restyle';
import { Skeleton } from '@components/shared/Skeleton';
import theme from '@themes/theme';

/**
 * Checklist item row placeholder: checkbox square + text line. Used for
 * both the Checklist tab and the Checklist Template modal.
 */
export const ChecklistRowSkeleton: React.FC<{ testID?: string }> = ({
  testID = 'checklist-row-skeleton',
}) => {
  return (
    <Box
      testID={testID}
      flexDirection='row'
      alignItems='center'
      paddingVertical='s'>
      <Skeleton
        variant='rect'
        width={18}
        height={18}
        borderRadius='xxs'
        style={{ marginRight: theme.spacing.s }}
      />
      <Box flex={1}>
        <Skeleton variant='text' width='50%' />
      </Box>
    </Box>
  );
};
